<script setup lang="ts">
import { watchEffect, ref, computed } from "vue";
import { atomReadStyle, atomWriteStyle } from "@zyzgroup/core-web";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    global?: boolean;
    color?: string;
  }>(),
  {
    global: true,
    color: "rgba(0, 0, 0, 0.25)"
  }
);

const emits = defineEmits<{
  (event: "open"): void;
  (event: "close"): void;
}>();

const el = ref();

const visible = ref(false);

// FOUC: flash of unstyled content 未样式化文本闪烁
const style = computed(
  () =>
    ({
      // v-if="visible" 使子元素重新创建 或 子元素 传不同 key 重新创建
      display: visible.value ? "block" : "none",
      // display: "block",
      position: "fixed",
      width: "100%",
      height: "100%",
      "z-index": "99999",
      inset: "0",
      "background-color": props.color,
      overflow: "hidden"
      // 'overscroll-behavior-y': 'contain' /* avoid scroll chaining */,
      // 'scrollbar-gutter': 'stable',
    } as Record<string, string>)
);

// fixScroll
let parentOverflow = "";
if (props.global) {
  parentOverflow =
    atomReadStyle(document.documentElement, "overflow") || "visible";
} else {
  watchEffect(() => {
    if (!el.value || parentOverflow) {
      // not mounted yet, or the element was unmounted (e.g. by v-if)
      return;
    }
    parentOverflow =
      atomReadStyle(el.value.parentElement, "overflow") || "visible";
    setOverflow();
  });
}

function setOverflow() {
  if (!parentOverflow) {
    return;
  }
  atomWriteStyle(
    props.global ? document.documentElement : el.value.parentElement,
    "overflow",
    visible.value ? "hidden" : parentOverflow
  );
}

function open() {
  visible.value = true;
  setOverflow();
  emits("open");
}

function close() {
  visible.value = false;
  setOverflow();
  emits("close");
}

defineExpose({ open, close });
</script>

<template>
  <div
    ref="el"
    class="overlay"
    :style="style"
  >
    <slot></slot>
  </div>
</template>
